/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "depot-pumps-management",
	props:{
		depotId: {
			default: null
		},
		depotName: {
			default: null
		}
	},
	data() {
		return {
			pumps: [],
			pumpsHeadings: [
				{
					text: "Pump Number/Tank Registration",
					field: "pumpNumberTankRegistration"
				},
				{
					text: "Is Active",
					field: "isActive"
				}
			],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			depot:{},
			actionKeys:{
				edit: "edit",
				markAsActiveInactive: "markAsActiveInactive"
			},
			pumpAddEditFormModal:{
				showModal: false,
				isSaving: false,
				modalId: "addEditPumpModal",
				heading: "Add Pump",
				pump:{
					depotPumpId: null,
					pumpNumberTankRegistration: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					depotId: null,
					bauzer: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					isActive: true
				}
			},
			pumpMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markAsActiveInactivePumpModal",
				heading: "Mark Pump As Active/Inactive",
				isActive: true,
				depotPumpId: null
			},
			filterStateChanged: false,
			filter:{
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getPumps() {
			this.loading = true;
			let request = {
				depotId: this.depotId,
				isActive: castingUtility.toBoolean(this.filter.activeOrInactiveItems),
				searchQuery: this.filter.customerSearchQuery,
			};
			systemService.getAllDepotPumpsByDepotId(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.pumps = successResponse.data.result;
						for(let i = 0; i < this.pumps.length; i++){
							this.pumps[i].actions = [
								{
									name: "Edit",
									key: this.actionKeys.edit
								},
								{
									name: this.pumps[i].isActive ? "Mark As Inactive" : "Mark As Active",
									key: this.actionKeys.markAsActiveInactive
								},
							];
						}
						this.pumps = dataTableHelper.castFieldValues(this.pumps);
						this.filterStateChanged = false;
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getDepot(){
			this.depot = {
				depotId: 1,
				name: "Depot 1",
				street: "123 Test Road",
				suburb: "Test Suburb",
				city: "Durban",
				postalCode: "4000",
				province: "KwaZulu-Natal",
				provinceId: 1,
				gpsCoordinates: "1234, 5678",
				primaryPhoneNumber: "0123456789",
				primaryEmailAddress: "test@test.com",
				isActive: true,
				insertedOn: new Date()
			};
			this.setBreadcrumbs();
		},
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			this.getPumps();
		},
		onActiveInactiveFilterSelected(activeOrInactiveKey){
			this.filter.activeOrInactiveItems = activeOrInactiveKey;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onAddPumpClick(){
			this.pumpAddEditFormModal.heading = "Add Pump";
			this.clearPumpModel();
			this.pumpAddEditFormModal.showModal = true;
		},
		onPumpActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			switch(actionAndData.action){
				case this.actionKeys.edit:
					this.pumpAddEditFormModal.showModal = true;
					this.pumpAddEditFormModal.heading = "Edit Pump";
					this.pumpAddEditFormModal.pump.depotPumpId = actionAndData.data.depotPumpId;
					this.pumpAddEditFormModal.pump.pumpNumberTankRegistration.value = actionAndData.data.pumpNumberTankRegistration;
					this.pumpAddEditFormModal.pump.depotId = actionAndData.data.depotId;
					this.pumpAddEditFormModal.pump.bauzer.value = actionAndData.data.bauzer;
					this.pumpAddEditFormModal.pump.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					break;
				case this.actionKeys.markAsActiveInactive:
					this.pumpMarkAsActiveInactiveModal.showModal = true;
					this.pumpMarkAsActiveInactiveModal.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					this.pumpMarkAsActiveInactiveModal.heading = "Mark Depot Pump As " + (this.pumpMarkAsActiveInactiveModal.isActive ? "Inactive" : "Active") + " - " + actionAndData.data.pumpNumberTankRegistration;
					this.pumpMarkAsActiveInactiveModal.depotPumpId = actionAndData.data.depotPumpId;
					break;
			}
		},
		onMarkPumpActiveInactiveSelected(isActive){
			this.pumpMarkAsActiveInactiveModal.isActive = isActive;
			console.log("pumpMarkAsActiveInactiveModal.isActive", this.pumpMarkAsActiveInactiveModal.isActive);
		},
		onMarkAsActiveInactiveSaveClick(markAsActive){
			this.pumpMarkAsActiveInactiveModal.isSaving = true;
			let request = {
				depotPumpId: this.pumpMarkAsActiveInactiveModal.depotPumpId,
				isActive: markAsActive
			};
			systemService.markDepotPumpAsActiveOrInactive(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.getPumps();
						this.pumpMarkAsActiveInactiveModal.showModal = false;
						this.pumpMarkAsActiveInactiveModal.isActive = true;
						this.pumpMarkAsActiveInactiveModal.depotId = null;
					}
					this.pumpMarkAsActiveInactiveModal.isSaving = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.pumpMarkAsActiveInactiveModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onAddOrEditPumpModalCloseClick(){
			this.pumpAddEditFormModal.showModal = false;
			this.clearPumpModel();
		},
		onAddOrEditPumpSaveClick(){
			this.pumpAddEditFormModal.isSaving = true;
			let request = {
				depotPumpId: this.pumpAddEditFormModal.pump.depotPumpId === null ? 0 : this.pumpAddEditFormModal.pump.depotPumpId,
				pumpNumberTankRegistration: this.pumpAddEditFormModal.pump.pumpNumberTankRegistration.value,
				depotId: this.depotId,
				bauzer: this.pumpAddEditFormModal.pump.bauzer.value,
				isActive: this.pumpAddEditFormModal.pump.isActive
			};
			systemService.addOrUpdateDepotPump(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.depotPumpValidationResponse.valuesAreValid){
							this.getPumps();
							this.pumpAddEditFormModal.showModal = false;
							this.clearPumpModel();
						}
						else{
							this.pumpAddEditFormModal.pump.pumpNumberTankRegistration.hasError = successResponse.data.depotPumpValidationResponse.pumpNumberTankRegistrationValidationResponse.hasError;
							this.pumpAddEditFormModal.pump.pumpNumberTankRegistration.errorMessage = successResponse.data.depotPumpValidationResponse.pumpNumberTankRegistrationValidationResponse.message;
							if(successResponse.data.depotPumpValidationResponse.depotValidationResponse.hasError){
								alert(successResponse.data.depotPumpValidationResponse.depotValidationResponse.message)
							}
						}
					}
					this.pumpAddEditFormModal.isSaving = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.pumpAddEditFormModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		clearPumpModel(){
			this.pumpAddEditFormModal.pump = {
				depotPumpId: null,
				pumpNumberTankRegistration: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				depotId: null,
				bauzer: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				isActive: true
			};
		},
		setBreadcrumbs() {
			var pageTitle = "Depot Pumps - " + this.depotName;
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted: function () {
	},
	watch:{
		depotId:{
			handler: function () {
				if (this.depotId !== null && this.depotId > 0) {
					this.getPumps();
					this.setBreadcrumbs();
				}
			},
			immediate: true,
			deep: true
		}
	}
};